export default __webpack_public_path__ + "84a3c9d9ab0b2419b0cdd251e74ae992.png";